import { useCallback, useState } from 'react';
import { getApiErrorMessage } from '@/lib/apiError';

/**
 * Envoi d'un formulaire ou d'une confirmation : submit(action) occupe le bouton (submitting) le temps de l'action,
 * et en cas d'échec garde le message d'erreur (par défaut celui de l'API) pour <FormError>.
 */
export function useSubmit(toMessage: (error: unknown) => string = getApiErrorMessage) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = useCallback(
    async (action: () => Promise<void>) => {
      setSubmitting(true);
      setError(null);
      try {
        await action();
      } catch (e) {
        setError(toMessage(e));
      } finally {
        setSubmitting(false);
      }
    },
    [toMessage],
  );

  return { submit, submitting, error };
}
